<template>
  <div class="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 chart-component">
    <div class="cust-pr">
      <div class="card padding-mainchart">
        <h6 class="card-title">
          {{ $t('dashboard.conversionStatistics') }}
          <hr>
        </h6>
        <div class="main-wr">
          <div class="btn-group btn-group-sm ml-cust">
            <button
              :class="{'active': typeRange === 'week'}"
              class="btn btn-sm btn-outline-primary btn-brd"
              @click="getMain(100); "
            >
              {{ $t('dashboard.week') }}
            </button>
            <button
              :class="{'active': typeRange === 'month'}"
              class="btn btn-sm btn-outline-primary btn-brd"
              @click="getMain(30);"
            >
              {{ $t('dashboard.month') }}
            </button>
            <button
              :class="{'active': typeRange === 'year'}"
              class="btn btn-sm btn-outline-primary btn-brd"
              @click="getMain(-30);"
            >
              {{ $t('dashboard.prev_month') }}
            </button>
          </div>
          <!--          <div-->
          <!--            class="err-data"-->
          <!--            v-if="$store.state.report.loadingmain !== false"-->
          <!--            v-loading="$store.state.report.loadingmain !== false"-->
          <!--          ></div>-->
          <!--          <div v-if="$store.state.report.dataerrmain == false || dCon" class="err-data">-->
          <!--            <p v-if="!$store.state.report.dataerrmain">-->
          <!--              {{ $t('alerts.dataTable.loadingError') }}-->
          <!--            </p>-->
          <!--            <p v-if="dCon && !$store.state.report.loadingmain">-->
          <!--              {{ $t('alerts.dataTable.noData') }}-->
          <!--            </p>-->
          <!--          </div>-->
          <UiChart :chart-options="conversationChartConfig" />
          <!--          <line-chart-->
          <!--            ref="resetChartMain"-->
          <!--            :configuration="mainChartConfig"-->
          <!--            :labels="arrayDate"-->
          <!--            :datasets="chart_datasets"-->
          <!--            :height="414"-->
          <!--            :d-reg="dReg"-->
          <!--          />-->
        </div>
      </div>
    </div>
    <div class="cust-pl-2">
      <div class="card padding-chart">
        <h6 class="card-title">
          {{ $t('dashboard.registrationStatistics') }}
          <hr>
        </h6>
        <div class="btn-group btn-group-sm ml-cust ml-cust-bottom">
          <button
            :class="{'active': typeRange1 === 'week'}"
            class="btn btn-sm btn-outline-primary btn-brd"
            @click="getMini(100);"
          >
            {{ $t('dashboard.week') }}
          </button>
          <button
            :class="{'active': typeRange1 === 'month'}"
            class="btn btn-sm btn-outline-primary btn-brd"
            @click="getMini(30);"
          >
            {{ $t('dashboard.month') }}
          </button>
          <button
            :class="{'active': typeRange1 === 'year'}"
            class="btn btn-sm btn-outline-primary btn-brd"
            @click="getMini(-30);"
          >
            {{ $t('dashboard.prev_month') }}
          </button>
        </div>
        <UiChart
          class="mt-8"
          :chart-options="registrationChartConfig"
        />
        <UiChart
          class="mt-8"
          :chart-options="depositsChartConfig"
        />
        <UiChart
          class="mt-8"
          :chart-options="netprofitChartConfig"
        />
        <!--        <chart-mini-->
        <!--          ref="resetChartMini1"-->
        <!--          :configuration="miniChartConfig1"-->
        <!--          :labels="arrayDateRegistration"-->
        <!--          :datasets="chart_datasets_reg"-->
        <!--          :height="138"-->
        <!--          :d-reg="dReg"-->
        <!--        />-->
        <!--        <chart-mini-->
        <!--          ref="resetChartMini2"-->
        <!--          :configuration="miniChartConfig2"-->
        <!--          :labels="arrayDateDeposits"-->
        <!--          :datasets="chart_datasets_dep"-->
        <!--          :height="138"-->
        <!--          :d-reg="dDep"-->
        <!--        />-->
        <!--        <chart-mini-->
        <!--          ref="resetChartMini3"-->
        <!--          :configuration="miniChartConfig3"-->
        <!--          :labels="arrayDateNetProfit"-->
        <!--          :datasets="chart_datasets_net_prof"-->
        <!--          :height="138"-->
        <!--          :d-reg="dNetProf"-->
        <!--        />-->
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import UiChart from '@/components/Charts/UiChart.vue';
import UrlMixin from '@/components/Query/url-mixin';
import HelpersMixin from '@/components/Helpers/helpers-mixin';
import formattedCurrency from '@/helpers/formattedCurrency';

const highchartsYTitleFontSize = 12;
const highchartsYTitleFontFamily = 'Open Sans, serif';

export default {
  components: {
    UiChart,
  },
  mixins: [
    UrlMixin,
    HelpersMixin,
  ],
  props: {
    currencyLabel: {
      type: String,
      default: '',
    },
  },
  emits: ['chartPeriod'],
  data() {
    return {
      conversationChartData: {
        categories: [],
        series: {
          visits: [],
          impressions: [],
        },
      },
      otherChartData: {
        categories: [],
        registrationSeries: [],
        depositsSeries: [],
        netprofiSeries: [],
      },

      chartPeriod: '',
      miniChartPeriod: '',
      typeRange: 'week',
      typeRange1: 'week',
    };
  },

  computed: {
    conversationChartConfig() {
      return {
        accessibility:{
          enabled: false,
        },
        colors: ['#008DDD', '#FF4B63'],
        chart: {
          height: 414,
          type: 'areaspline',
          spacing:[20, 0, 20, 0],

        },
        title: {
          text:'',
        },
        credits: {
          enabled: false,
        },
        legend: {
          verticalAlign: 'top',
        },
        plotOptions: {
          areaspline: {
            marker: {
              symbol: 'curcle',
              radius: 3.5,
              lineWidth: 1,
              states: {
                hover: {
                  enabledThreshold: 2,
                  radius: 4.5,
                  radiusPlus: 0,
                  lineWidthPlus: 0.5,
                },
              },
            },
            fillOpacity: 0.1,
            lineWidth: 1,
          },
        },
        xAxis: {
          categories: this.conversationChartData.categories,
          reversed: true,
          labels: {
            style: {
              fontSize: highchartsYTitleFontSize,
              fontFamily: highchartsYTitleFontFamily,
            },
          },
        },
        yAxis: [
          {
            title: {
              text: this.$t('dashboard.impressions_count'),
              style: {
                fontSize: highchartsYTitleFontSize,
                fontFamily: highchartsYTitleFontFamily,
              },
            },
            opposite: true,
          },
          {
            title: {
              text: this.$t('dashboard.visits_count'),
              style: {
                fontSize: highchartsYTitleFontSize,
                fontFamily: highchartsYTitleFontFamily,
              },
            },
            gridLineWidth: 0,
          },
        ],
        tooltip: {
          shared: true,
          headerFormat: '{key}<br>',
        },
        series: [{
          name: this.$t('dashboard.visits_count'),
          yAxis: 1,
          data: this.conversationChartData.series.visits,
        }, {
          name: this.$t('dashboard.impressions_count'),
          data: this.conversationChartData.series.impressions,
        }],
      };
    },
    registrationChartConfig() {
      return {
        accessibility:{
          enabled: false,
        },
        colors: ['#3F9A20'],
        chart: {
          height: 138,
          type: 'areaspline',
          spacing:[10, 0, 10, 0],
        },
        title: {
          text:'',
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            marker: {
              symbol: 'curcle',
              radius: 3.5,
              lineWidth: 1,
              states: {
                hover: {
                  enabledThreshold: 2,
                  radius: 4.5,
                  radiusPlus: 0,
                  lineWidthPlus: 0.5,
                },
              },
            },
            fillOpacity: 0.1,
            lineWidth: 1,
          },
        },
        xAxis: {
          categories: this.otherChartData.categories,
          reversed: true,
          minPadding:0,
          labels: {
            style: {
              fontSize: highchartsYTitleFontSize,
              fontFamily: highchartsYTitleFontFamily,
            },
          },
        },
        yAxis: [
          {
            title: {
              text: this.$t('dashboard.registration'),
              style: {
                fontSize: highchartsYTitleFontSize,
                fontFamily: highchartsYTitleFontFamily,
              },
            },
            tickAmount: 3,
          },
          {
            opposite: true,
            title: '',
            tickAmount: 3,
          },
        ],
        tooltip: {
          shared: true,
          headerFormat: '{key}<br>',
        },
        series: [{
          name: this.$t('dashboard.registration'),
          yAxis: 1,
          data: this.otherChartData.registrationSeries,
        }],
      };
    },
    depositsChartConfig() {
      return {
        accessibility:{
          enabled: false,
        },
        colors: ['#ffce06'],
        chart: {
          height: 138,
          type: 'areaspline',
          spacing:[10, 0, 10, 0],
        },
        title: {
          text:'',
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            marker: {
              symbol: 'curcle',
              radius: 3.5,
              lineWidth: 1,
              states: {
                hover: {
                  enabledThreshold: 2,
                  radius: 4.5,
                  radiusPlus: 0,
                  lineWidthPlus: 0.5,
                },
              },
            },
            fillOpacity: 0.1,
            lineWidth: 1,
          },
        },
        xAxis: {
          categories: this.otherChartData.categories,
          reversed: true,
          minPadding:0,
          labels: {
            style: {
              fontSize: highchartsYTitleFontSize,
              fontFamily: highchartsYTitleFontFamily,
            },
          },
        },
        yAxis: [
          {
            title: {
              text: this.$t('dashboard.deposits'),
              style: {
                fontSize: highchartsYTitleFontSize,
                fontFamily: highchartsYTitleFontFamily,
              },
            },
          },
          {
            opposite: true,
            title: '',
            tickAmount: 3,
          },
        ],
        tooltip: {
          shared: true,
          headerFormat: '{key}<br>',
        },
        series: [{
          name: this.$t('dashboard.deposits'),
          yAxis: 1,
          data: this.otherChartData.depositsSeries,
        }],
      };
    },
    netprofitChartConfig() {
      const formatTooltip = this.formatTooltip;
      return  {
        accessibility:{
          enabled: false,
        },
        colors: ['#4612ee'],
        chart: {
          height: 138,
          type: 'areaspline',
          spacing:[10, 0, 10, 0],
        },
        title: {
          text:'',
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            marker: {
              symbol: 'curcle',
              radius: 3.5,
              lineWidth: 1,
              states: {
                hover: {
                  enabledThreshold: 2,
                  radius: 4.5,
                  radiusPlus: 0,
                  lineWidthPlus: 0.5,
                },
              },
            },
            fillOpacity: 0.1,
            lineWidth: 1,
          },
        },
        xAxis: {
          categories: this.otherChartData.categories,
          reversed: true,
          minPadding:0,
          labels: {
            style: {
              fontSize: highchartsYTitleFontSize,
              fontFamily: highchartsYTitleFontFamily,
            },
          },
        },
        yAxis: [
          {
            title: {
              text: this.$t('dashboard.net_profit_sum'),
              style: {
                fontSize: highchartsYTitleFontSize,
                fontFamily: highchartsYTitleFontFamily,
              },
            },
          },
          {
            opposite: true,
            title: '',
            tickAmount: 3,
            labels: {
              formatter: (data) => {
                if (data.value % 1 === 0) {
                  return `${this.currencyLabel}${data.value}`;
                }
              },
            },
          },
        ],
        tooltip: {
          shared: true,
          formatter: function () {
            const val = formatTooltip(this.y, this.key, this.series.name, this.color);
            return `${val}`;
          },
        },
        series: [
          {
            name: this.$t('dashboard.net_profit_sum'),
            yAxis: 1,
            data: this.otherChartData.netprofiSeries,
          },
        ],
      };
    },

    chartData() {
      return this.$store.state.report.chart;
    },
    chartDataMini() {
      return this.$store.state.report.chartmini;
    },
  },
  watch: {
    '$i18n.locale': function () {
      if (this.isComponentActivated) {
        setTimeout(() => {
          this.chartRender(this.chartData);
          this.chartOtherRender(this.chartDataMini);
        }, 300);
      }
    },

    chartDataMini(chart) {
      if (chart.length) {
        this.chartOtherRender(chart);
      }
    },
    chartData(chart) {
      if (chart.length) {
        this.chartRender(chart);
      }
    },
  },
  activated() {
    if (localStorage.getItem('auth-token') !== 'null') {
      this.getMain(this.chartPeriod || 100);
      this.getMini(this.miniChartPeriod || 100);
    }
  },
  created() {
    // this.$on('refresh', () => {
    //   this.getMain(this.chartPeriod || 100);
    //   this.getMini(this.miniChartPeriod || 100);
    // });
  },

  mounted() {
    this.chartPeriod = this.getUrlQueryParam('chartPeriod');
    this.miniChartPeriod = this.getUrlQueryParam('miniChartPeriod');
    if (localStorage.getItem('auth-token') !== 'null') {
      this.getMain(this.chartPeriod || 100);
      this.getMini(this.miniChartPeriod || 100);
    }
  },
  methods: {
    formatTooltip(y, key, name, color) {
      return `${key}<br> <span style="color:${color}">\u25CF</span> ${name}: <b>${this.currencyLabel}${formattedCurrency(y)}</b>`;
    },

    chartRender(chart) {
      this.conversationChartData = chart.reduce((acc, elem) => {
        acc.categories.push(moment(elem.row_id).format('MMM DD'));
        acc.series.visits.push(elem.visits_count);
        acc.series.impressions.push(elem.impressions_count);
        return acc;
      }, {
        categories: [],
        series: {
          visits: [],
          impressions: [],
        },
      });
    },
    chartOtherRender(chart) {
      this.otherChartData = chart.reduce((acc, elem) => {
        acc.categories.push(moment(elem.row_id).format('MMM DD'));
        acc.registrationSeries.push(elem.registrations_count);
        acc.depositsSeries.push(elem.deposits_all_count);
        acc.netprofiSeries.push(elem.net_profit_sum);
        return acc;
      }, {
        categories: [],
        registrationSeries: [],
        depositsSeries: [],
        netprofiSeries: [],
      });
    },

    resetChartMain() {
      this.$refs.resetChartMain.$data._chart.resetZoom();
    },

    resetChartMini(v) {
      switch (v) {
        case 1:
          this.$refs.resetChartMini1.$data._chart.resetZoom();
          break;
        case 2:
          this.$refs.resetChartMini2.$data._chart.resetZoom();
          break;
        case 3:
          this.$refs.resetChartMini3.$data._chart.resetZoom();
      }
    },

    setPeriod(period) {
      const firstDayOfMonth = moment().startOf('month');
      const firstDayOfWeek = moment().startOf('week');
      const firstDayOfYear = moment().startOf('year');
      const lastDayOfMonth = moment().endOf('month');
      const lastDayOfWeek = moment().endOf('week');
      const lastDayOfYear = moment().endOf('year');
      const endOfDay = moment().endOf('day');
      const now = new Date();

      let start = new Date();
      let end = new Date();

      switch (period) {
        // last month
        case -30:
          start = moment(firstDayOfMonth).subtract(1, 'months');
          end = moment(lastDayOfMonth).subtract(1, 'months');
          break;
        // -30 days
        case 100:
          start = (() => {
            const d = new Date();
            d.setDate(d.getDate() - 30);
            return moment(d).startOf('day');
          })();
          end = endOfDay;
          break;
        // this month
        case 30:
          start = firstDayOfMonth;
          end = endOfDay;
          break;
        default:
          start = (() => {
            const d = new Date();
            d.setDate(d.getDate() - 30);
            return moment(d).startOf('day');
          })();
          end = endOfDay;
      }
      start = `${moment(start).format('YYYY-MM-DD HH:mm:ss')}`;
      end = `${moment(end).format('YYYY-MM-DD HH:mm:ss')}`;
      return { from: start, to: end };
    },

    getMini(period) {
      switch (period) {
        case 100:
          this.typeRange1 = 'week';
          break;
        case 30:
          this.typeRange1 = 'month';
          break;
        case -30:
          this.typeRange1 = 'year';
          break;
        default:
          this.typeRange1 = 'week';
      }
      this.chartPeriod = period;
      const miniRange = this.setPeriod(period);

      this.$store.dispatch('getStatisticsMini', miniRange).then((data) => {
        this.$emit('chartPeriod', { type: 'mini', period });
      });
    },

    getMain(period) {
      switch (period) {
        case 100:
          this.typeRange = 'week';
          break;
        case 30:
          this.typeRange = 'month';
          break;
        case -30:
          this.typeRange = 'year';
          break;
        default:
          this.typeRange = 'week';
      }

      this.chartPeriod = period;
      const mainRange = this.setPeriod(period);

      this.$store.dispatch('getStatistics', mainRange).then(() => {
        this.$emit('chartPeriod', { type: 'normal', period });
      });
    },
  },
};
</script>

<style lang="scss">
.chart-component {
  .mini-wr,
  .main-wr {
    position: relative;
    .err-data {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 50px;
      width: 150px;
      margin: auto;
      z-index: 1;
      opacity: 0.7;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .reset-chart {
      opacity: 0.7;
      text-transform: uppercase;
      position: absolute;
      right: 50px;
      transition: all 0.3s;
      z-index: 1;
      &:hover {
        cursor: pointer;
        opacity: 1;
      }
    }
  }
  .main-wr .err-data {
    font-size: 20px;
  }
  .padding-mainchart, .padding-chart{
    padding-bottom: 10px !important;
    .card-title {
      margin-bottom: 0;
    }
  }
  .padding-mainchart {
    position: relative;
    .reset-chart {
      position: absolute;
      text-transform: uppercase;
      right: 60px;
      top: 130px;
      opacity: 0.7;
      transition: all 0.3s;
      z-index: 1;
      &:hover {
        cursor: pointer;
        opacity: 1;
      }
      span {
        &::selection {
          background: transparent;
        }
      }
    }
  }
  .ml-cust {
    z-index: 2;
    .btn-sm.btn-outline-primary {
      padding: 4px 0px;
    }
  }
  .btn-group {
    .btn-brd {
      width: 30%;
    }
  }
  .cust-pr {
    padding-left: 0;
    padding-right: 8px;
  }
  .cust-pl-2 {
    padding-left: 8px;
    padding-right: 0;
  }
  .ml-cust {
    display: flex;
    justify-content: center;
  }
  @media (max-width: 1200px) {
    .cust-pl-2 {
      padding-left: 0px;
    }
    .cust-pr {
      padding-right: 0;
      padding-bottom: 24px;
    }
  }
  @media (max-width: 650px) {
    .padding-mainchart, .padding-chart{
      padding: 16px 16px 4px !important;
      h6{
        font-size: 14px;
      }
    }
    .ml-cust {
      padding: 0 !important;
      .btn {
        width: 100%;
      }
    }
    .ml-cust-bottom {
      padding: 0 !important;
    }
  }
}
</style>
